import {RentsFilter} from "@olivades/pattern-lib";

export const capacitiesFilter: RentsFilter = {
  name: "capacity",
  values: [
    {name: "2", value: 2},
    {name: "3", value: 3},
    {name: "4", value: 4}
  ]
}


export const amenitiesFilter: RentsFilter = {
  name: "equipments",
  values: [
    {name: "private-spa", value: "private-spa"}
  ]
}
